"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = {
  // Marketing Basic/Pro/Enterprise have `hub-marketing-product`.
  HUB_MARKETING_PRODUCT: 'hub-marketing-product',
  HUB_CRM_PRODUCT: 'hub-crm-product',
  LEAD_FLOWS_CUSTOM_FIELDS_ACCESS: 'lead-flows-custom-fields-access',
  LEADIN_NO_BRANDING: 'leadin-no-branding',
  VERIFIED_EMAIL: 'verified-email',
  CONTACTS_TIMELINE_UNLIMITED_ANALYTICS: 'contacts-timeline-unlimited-analytics',
  MARKETING_STARTER_PRODUCT: 'marketing-starter-product',
  AUDIENCE_TARGETING_ADVANCED_RULES: 'audience-targeting-advanced-rules',
  AUDIENCE_TARGETING_ESSENTIAL_RULES: 'audience-targeting-essential-rules'
};
exports.default = _default;
module.exports = exports.default;